export default {"src":"/_next/static/image/public/images/ic_upload_green.9776d8f357dcd337363e023ee444d55a.svg","height":16,"width":16};